import SmallTextLink from 'components_v2/SignIn/common/SmallTextLink'
import styled from 'styled-components'

const StyledLink = styled(SmallTextLink)`
  text-align: left;
  margin: 0;

  span {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 4px;
  }
`

export default StyledLink
